// extracted by mini-css-extract-plugin
export default {"editButton":"Item_editButton__fmRvU","labelButton":"Item_labelButton__cyb8q","labelButtonActive":"Item_labelButtonActive__wiSjX","wrapper":"Item_wrapper__AHpTi"};